/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {AdminRole} from './AdminRole';

export const AdminRoles = yup.object({roles: yup.array().of(AdminRole)});

export type IAdminRoles = yup.InferType<typeof AdminRoles>;
